// extracted by mini-css-extract-plugin
export var aiStarIcon = "_am-4";
export var closeButton = "_am-6";
export var dismissButton = "_am-3";
export var editImageWithAiContainer = "_am-8";
export var imageUploadWrapper = "_am-7";
export var misspelledWord = "_am-5";
export var spellCheckContainer = "_am-2";
export var spin = "_am-1";
export var spinning = "_am-0";